"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateOccupation = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var inputs_component_1 = require("../../../components/inputs.component");
var ajax_util_1 = require("../../../utils/ajax/ajax.util");
var constants_1 = require("../../../constants");
var form_hooks_1 = require("../../../utils/forms/form-hooks");
var pp_react_1 = require("@paypalcorp/pp-react");
var occupation_1 = require("../../../actions/occupation");
var commonweb_utils_1 = require("commonweb-utils");
var ROUTES = constants_1.default.ROUTES, VIEWS = constants_1.default.VIEWS;
var page = require("page");
exports.UpdateOccupation = function (props) {
    var initializer = function () {
        return {
            form: {
                occupationInput: {
                    elementType: "select",
                    elementConfig: {
                        options: props.dropDownData,
                        placeholder: props.occupationContent.placeholder,
                        label: props.occupationContent.label,
                        suggestionText: props.occupationContent.invalidSelectionError,
                    },
                    value: props.selectedOccupation || "",
                    validation: {
                        required: true,
                    },
                    isValid: !!props.selectedOccupation,
                    isTouched: !!props.selectedOccupation,
                },
            },
            formIsValid: false,
            formMessage: "",
        };
    };
    var submitHandle = function (event) {
        var formData = {}, formElementIdentifier = "occupationInput", form = inputs.form;
        formData[formElementIdentifier] = form[formElementIdentifier].value;
        // If there is no user selection and dropdown has an empty value,
        // force change handler to validate and show error text with DropDown component
        if (!form[formElementIdentifier].isTouched) {
            inputChangedHandler(event, formElementIdentifier, true);
        }
        // Error message is displayeed part of the component, just return
        if (!inputs.formIsValid && !form[formElementIdentifier].value) {
            return;
        }
        ajax_util_1.default.post$(props.dispatch, props._csrf, "" + ROUTES.API.OCCUPATION.UPDATE, formData, { component: { name: VIEWS.UPDATE_OCCUPATION } })
            .then(function (occupationInfo) {
            if (occupationInfo &&
                !occupationInfo.error &&
                occupationInfo.data &&
                occupationInfo.data.status === 200) {
                var isFlow = props.route.isFlow || false, flowName = props.route.enter.flow || "";
                props.dispatchOccupationChange({
                    selectedOccupation: occupationInfo.data.selectedOccupation,
                });
                props.transitionOutHandler();
                if (isFlow) {
                    page(constants_1.default.BASE_URI + "/flow-return/" + flowName + "?success=true");
                }
                else {
                    page.redirect(constants_1.default.BASE_URI + "?success=true");
                }
            }
            else {
                setFormMessage(props.commonContent.genericServerError);
            }
        })
            .catch(function (error) {
            var errorStatusCode = commonweb_utils_1.objectUtils.safeGet(error, "error.statusCode") || 500;
            if (errorStatusCode >= 400 && errorStatusCode < 500) {
                setFormMessage(props.commonContent.submitError);
            }
            else {
                setFormMessage(props.commonContent.genericServerError);
            }
            return;
        });
    };
    var getForm = function () {
        var formElementsArray = [];
        var occupationContent = props.occupationContent, commonContent = props.commonContent, fpti = props.fpti, route = props.route, ui = props.ui, showSpinner = ui.showSpinner, action = commonweb_utils_1.objectUtils.safeGet(route, "enter.params.action") || "", isFlow = route.isFlow || false, flowName = commonweb_utils_1.objectUtils.safeGet(route, "enter.flow") || "", headerContent = action === "add"
            ? occupationContent.addHeader
            : occupationContent.updateHeader, skipLink = isFlow
            ? constants_1.default.BASE_URI + "/flow-cancel/" + flowName
            : constants_1.default.BASE_URI, form;
        for (var key in inputs.form) {
            formElementsArray.push({
                id: key,
                config: inputs.form[key],
            });
        }
        form = (React.createElement("form", { onSubmit: submitHandler, "aria-label": headerContent, "aria-describedby": "message_occupationInput occupation-body", tabIndex: 0 },
            inputs.formMessage ? (React.createElement(pp_react_1.Alert, { type: "error", className: "alignLeft occupation-alert" }, inputs.formMessage)) : null,
            React.createElement(pp_react_1.Text, { size: "xl3", id: "message_occupationInput", className: "text_alignCenter test_occupation-header" }, headerContent),
            React.createElement(pp_react_1.Text, { size: "md", id: "occupation-body", className: "occupation-body test_occupation-body" }, occupationContent.body),
            formElementsArray.map(function (formElement) { return (React.createElement(inputs_component_1.default, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, value: formElement.config.value, isInvalid: !formElement.config.isValid, shouldValidate: formElement.config.validation, isTouched: formElement.config.isTouched, changed: function (event) {
                    return inputChangedHandler(event, formElement.id);
                } })); }),
            React.createElement(pp_react_1.Button, { name: fpti.submit, className: "occupation-save test_occupation-save", type: "submit", title: commonContent.save },
                React.createElement(pp_react_1.Text, { size: "md", medium: true }, commonContent.save)),
            React.createElement(pp_react_1.Link, { className: "text_alignCenter test_occupation-skiplink", href: skipLink, title: commonContent.skipLink }, commonContent.skipLink)));
        return (React.createElement("div", { className: "generic-container" }, showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "panelSpinnerNew", size: "lg" })) : (form)));
    };
    var _a = form_hooks_1.default(initializer(), submitHandle), inputs = _a.inputs, inputChangedHandler = _a.inputChangedHandler, submitHandler = _a.submitHandler, setFormMessage = _a.setFormMessage;
    return getForm();
};
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account, fpti = _a.fpti;
    var occupationList = commonweb_utils_1.objectUtils.safeGet(account, "occupation.occupationList") || [], occupationContent = content.occupation;
    return {
        _csrf: _csrf,
        route: route,
        ui: ui,
        occupationContent: occupationContent,
        commonContent: content.common,
        dropDownData: occupationList.map(function (key) {
            return {
                optionValue: occupationContent[key],
                optionId: key,
            };
        }) || [],
        selectedOccupation: commonweb_utils_1.objectUtils.safeGet(account, "occupation.selectedOccupation"),
        fpti: fpti.occupation,
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        dispatchOccupationChange: function (occupationInfo) {
            return dispatch(occupation_1.changeOccupation(occupationInfo));
        },
        dispatch: dispatch,
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.UpdateOccupation);
